import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow } from '@refinedev/core'
import { Typography } from 'antd'
import type { Tables } from '@muaa/shared'

type Album = Tables<'albums'>

const { Title } = Typography

export function AlbumShow() {
  const { query } = useShow<Album>()
  const isLoading = query.isLoading
  const record = query.data?.data

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Name</Title>
      <TextField value={record?.name ?? '—'} />

      <Title level={5}>Created</Title>
      {record?.created_at ? (
        <DateField value={record.created_at} format="MMM D, YYYY h:mm A" />
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
